export enum ActiveModeEnum {
  view = 'view',
  edit = 'edit',
  create = 'create',
  build = 'build',
}
